// ***********************************
// *****  global site variables  *****
// ***********************************

// language detection

const siteLang = document.querySelector('html').getAttribute('lang') ? document.querySelector('html').getAttribute('lang').toLowerCase() : 'en';

const detectReducedMotionPref = window.matchMedia('(prefers-reduced-motion: reduce)');
let settingsLinksAdded = false,
    settingsModalContent = null;

// site settings

const addSettingsLinks = () => {
    // utility bar link?
    let utilityBar = document.body.querySelector('.header--utility-bar--links ul');
    if(utilityBar != null) {
        let li = document.createElement('li');
        li.classList.add('list-inline-item','ms-2');
        li.innerHTML = '<button class="btn btn-link p-0 ml-3 site-settings-toggle" data-bs-toggle="modal" data-bs-target="#site-settings"><i class="fas fa-cog" aria-hidden="true" title="Site settings"></i><span class="visually-hidden">Site settings</span></button>';
        utilityBar.appendChild(li);
    }
    // update state
    settingsLinksAdded = true;
};

const refreshModalContent = () => {
    if(!settingsModalContent) {
        let settingsModal = document.createElement('div');
        settingsModal.setAttribute('id','site-settings');
        settingsModal.setAttribute('class','modal fade');
        settingsModal.setAttribute('data-bs-backdrop','static');
        settingsModal.setAttribute('data-bs-keyboard','false');
        settingsModal.setAttribute('tabindex','-1');
        settingsModal.setAttribute('aria-hidden','true');
        settingsModal.innerHTML = '<div class="modal-dialog"><div class="modal-content"><div class="modal-header"><h1 class="modal-title h5 m-0">Site Settings</h1><button type="button" class="btn btn-link p-0" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times" aria-hidden="true" title="Close"></i></button></div><div class="modal-body"></div></div>';
        document.body.appendChild(settingsModal);
        settingsModalContent = document.body.querySelector('#site-settings .modal-body');
    }
    let content = '';
    if(siteSettings.fx.length > 0) {
        settingsModalContent.innerHTML = '<p>Manage the visual effects on this site:</p>';
        siteSettings.fx.forEach(i => {
            settingsModalContent.appendChild(i.controller);
        });
    }
}

export const siteSettings = {
    reducedMotionPref: detectReducedMotionPref.matches,
    fx: [],
    fxAdd: (fxType, fxEnable, fxCallback = null) => {
        let exists = false;
        siteSettings.fx.forEach(i => {
            if(i.type == fxType) exists = true;
        });
        if(!exists) {
            siteSettings.fx.push({
                type: fxType,
                enabled: fxEnable,
                callback: fxCallback,
                controller: document.createElement('div')
            });
            let thisIndex = siteSettings.fx.length - 1,
                thisFX = siteSettings.fx[thisIndex];
            thisFX.controller.setAttribute('class','form-check form-switch');
            let checkbox = document.createElement('input');
            checkbox.setAttribute('id',`site-settings--fx--${thisIndex}`);
            checkbox.setAttribute('class','form-check-input');
            checkbox.setAttribute('type','checkbox');
            checkbox.setAttribute('role','switch');
            if(fxEnable) checkbox.setAttribute('checked',true);
            checkbox.addEventListener('click',() => {
                siteSettings.fxToggle(thisFX.type,checkbox.checked);
            });
            thisFX.controller.appendChild(checkbox);
            let label = document.createElement('label');
            label.setAttribute('for',`site-settings--fx--${thisIndex}`);
            label.setAttribute('class','form-check-label');
            label.innerHTML = thisFX.type;
            thisFX.controller.appendChild(label);
        }
        if(fxCallback) fxCallback(fxEnable);
        // add settings links if not already added
        if(!settingsLinksAdded) addSettingsLinks();
        // refresh modal content
        refreshModalContent();
    },
    fxToggle: (fxType, mode) => {
        siteSettings.fx.forEach(i => {
            if(i.type == fxType) {
                i.enabled = mode;
                if(i.callback) i.callback(mode);
            }
        });
    }
};

// viewport size

export const viewport = {
    vw: 0,
    vh: 0,
    setVw: (val) => {
        viewport.vw = val;
    },
    setVh: (val) => {
        viewport.vh = val;
    }
};

// component states

export const mainNavigation = {
    mobileActive: false,
    setMobileActive: (mode) => {
        mainNavigation.mobileActive = mode;
    },
    desktopActive: false,
    setDesktopActive: (mode) => {
        mainNavigation.desktopActive = mode;
    }
};

export const headerSearch = {
    active: false,
    setActive: (mode) => {
        headerSearch.active = mode;
    }
};